export enum ETimelineMode {
  OriginalTime,
  EditedTime,
}
